export default __webpack_public_path__ + "static/media/taller.52807b6f.jpg";